module.exports = __webpack_public_path__ + "img/gerador_violeta.16de13bd.jpeg";